import { el } from 'redom';
import FieldLabel from 'generics/components/field-label';

class InputRow {

  constructor(configuration) {

    this.input = configuration.input;
    const className = configuration.class || '';

    this.el = el('.form-input-row', {
      class: className
    }, [
      new FieldLabel({ text: configuration.label, tip: configuration.tip }),
      this.input
    ]);

  }

}

export default InputRow;